import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'eu',
    conver: 'en-GB',
    alia: 'eu',
    region: 'Europe',
    regionText: 'Europe',
    language: 'Europe',
    languageText: 'Europe',
    appId: 9,
    acceptLanguage: 'en-EU,en;q=0.9',
};
export default theLocale;
